import React from 'react';
import ReactDOM from 'react-dom';
import {message} from 'antd';
import './index.css';
import App from './App';
import 'moment/locale/zh-cn';
import {applyMiddleware, compose, createStore} from 'redux'
import {createHashHistory} from 'history';
import {connectRouter, routerMiddleware} from 'connected-react-router'
import ReduxThunk from 'redux-thunk'
import {Provider} from 'react-redux'
import {setStore} from "./utils/Util";
import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; //'redux-persist/lib/storage/session';
import {PersistGate} from 'redux-persist/integration/react'
import rootReducer from './reducers'



const history = createHashHistory()

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const middlewares = [ReduxThunk, routerMiddleware(history)];
if (process.env.NODE_ENV === `development`) {
    const {logger} = require(`redux-logger`);
    middlewares.push(logger);
}
const persistConfig = {
    key: 'pc-root',
    storage,
};
const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(
    connectRouter(history)(persistedReducer),
    composeEnhancer(
        applyMiddleware(...middlewares),
    ),
);
const persistor = persistStore(store);

// 把store保存到util中，为了接口返回鉴权失败时统一跳转到登录页面
setStore(store);
ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App history={history}/>
        </PersistGate>
    </Provider>,
    document.getElementById('root'));

